export async function requestAiGeneration({ apiUrl, token, payload, fetchImpl = fetch }) {
  const response = await fetchImpl(`${apiUrl}/api/ai/generate`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    credentials: 'include',
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const err = await response.json();
    throw new Error(err.detail || 'AI generation failed');
  }

  return response.json();
}
